// extracted by mini-css-extract-plugin
export default {"avatarRoot":"Avatar_avatarRoot__K8W+P","avatarImage":"Avatar_avatarImage__orDQc","avatarFallback":"Avatar_avatarFallback__LY-0Y"};